<template>
	<div class="w1">
	<div>
		<home-toutiao @showLogin="showLogin"/>
		<home-jianbao @showLogin="showLogin"/>
		<home-pinglun @showLogin="showLogin"/>
		<div class="m_b1"></div>
		<home-zhuanti @showLogin="showLogin"/>
		<div class="m_b1"></div>
		<home-shushuo @showLogin="showLogin"/>
		<!-- <home-zhishu/> -->
		<div class="m_b1" style="margin-bottom: 38px;"></div>
		<home-zhuanjia/>
		<!-- <home-lianjie/> -->
		<div class="m_b1"></div>
	</div>
	</div>
</template>

<script>
	import HomeToutiao from '@/components/home-toutiao.vue'
	import HomeJianbao from '@/components/home-jianbao.vue'
	import HomePinglun from '@/components/home-pinglun.vue'
	import HomeZhuanti from '@/components/home-zhuanti.vue'
	import HomeShushuo from '@/components/home-shushuo.vue'
	// import HomeZhishu from '@/components/home-zhishu.vue'
	import HomeZhuanjia from '@/components/home-zhuanjia.vue'
	// import HomeLianjie from '@/components/home-lianjie.vue'
	
	export default {
	
		name: 'home',
		components: {
			HomeToutiao,
			HomeJianbao,
			HomePinglun,
			HomeZhuanti,
			HomeShushuo,
			// HomeZhishu,
			HomeZhuanjia,
			// HomeLianjie,
		},
		created:function(){
			
		},
		mounted:function(){
			document.title='首页-中经专网';
			this.$track([
				['pagetype','首页']
			]);
		},
		methods:{
			showLogin: function() {
				this.$emit('showLogin');
			},
		},
		beforeRouteLeave(to,from,next){
			debugger
			if(!this.$cookies.get('userinfo')){
				// alert('未登录');
				this.showLogin();
				this.$cookies.set('fromdetail',to.fullPath);
				next(false);
			}
			else{
				next();
			}
		}
	}
</script>

<style>
</style>
